<template>
  <div>
    <b-row class='mb-3'>
      <b-col cols="12">
        <b-table
          striped
          hover
          sort-icon-left
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="dataItems"
          :fields="dataFields"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueSimplemde from "vue-simplemde";
  import { sendRequest } from '@/api'

  import {
    LOCALES,
  } from '@/const'
  
  export default {
    props: ['id'],
    data() {
      return {
        locales: LOCALES,
        sortBy: 'votes',
        sortDesc: true,
        dataFields: [
          { key: 'event_id', sortable: true },
          { key: 'event_name', sortable: true },
          { key: 'scene_name', sortable: true },
          { key: 'date_from', sortable: true },
          { key: 'date_to', sortable: true },
          { key: 'votes', sortable: true },
        ],
        dataItems: [],
        events: [],
      }
    },
    mounted() {
      sendRequest('get', `api/fanzine/vote/${this.id}/result/`)
        .then((result) => {
          const { data: { meta, data: items } } = result;
          if (meta && meta.status === 'ok' && items) {
            const events = this.getEvents();
            this.setDataItems(items, events);
          }
        })
    },
    methods: {
      setDataItems(items, events) {
        this.dataItems = items.map((it) => {
          const event = events.find((e) => e.id === it.fanzine_event_id);

          return {
            isActive: true,
            event_id: it.fanzine_event_id,
            event_name: it.fanzine_event_name,
            scene_name: event ? event.sceneName : '',
            votes: it.count,
            date_from: event ? this.$moment(event.dateFrom).format('YYYY-MM-DD, HH:mm') : '-',
            date_to: event ? this.$moment(event.dateTo).format('YYYY-MM-DD, HH:mm') : '-',
          }
        });
      },
      getEvents() {
        const result = [];
        this.$store.state.fanzones.form.doc.scenesData.scenes.map((scene) => {
          scene.events && scene.events.map((event) => {
            result.push({
              ...event,
              sceneName: scene.name.pl
            });
          })
        });
        return result;
      },
    },
    computed: {
      form() {
        return this.$store.state.fanzones.form
      }
    },
  }
</script>